import React, { useEffect, useState } from 'react'
import CryptoJS from 'crypto-js'
import { ApiType, EncKeys, MicroservicesBaseUrl } from '../../../config'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    calculateTransactionCharges,
    createPaymentRequestData,
} from '../../redux/actions/ComponentCallsActions'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import {
    Card,
    Grid,
    InputAdornment,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    Box,
} from '@mui/material'
import { PersonPin } from '@mui/icons-material'
import { alertService } from '../../services/alert-service'
import axios from 'axios'
import { formatCurrency } from 'globalize'
import bank from './NBWallet.json' 

const JioPayNetBanking = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()


    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
    const paymentData = useSelector((state) => state.customerData)
    const [cardYears, setcardYears] = useState([])
    const [charges,setCharges] = useState()
    const [axisState, setAxisState] = useState({
        cvv: '',
        cardHolder: '',
        cardNumber: '',
        month: '',
        year: '',
    })

const bankOptions = bank;
const [selectedBankCode, setSelectedBankCode] = useState('');

const nbBanks = bankOptions.filter(
  (b) => String(b.supportPaymentMode ?? '').trim().toLowerCase() === 'nb'
);


    const handleMonthChange = ({ target: { name, value } }) => {
        let temp = { ...axisState }
        temp.month = value
        setAxisState(temp)
    }


    const handleYearChange = ({ target: { name, value } }) => {
        let temp = { ...axisState }
        temp.year = value
        setAxisState(temp)
    }

    const handleChange = ({ target: { name, value } }) => {
        if (name === 'cardHolder') {
            const alphaValue = value.replace(/[^a-zA-Z\s]/g, '')
            let temp = { ...axisState }
            temp.cardHolder = alphaValue
            setAxisState(temp)
        } else if (name === 'cvv') {
            const number = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.cvv = number
            setAxisState(temp)
        } else if (name === 'cardNumber') {
            const filteredValue = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.cardNumber = filteredValue
            setAxisState(temp)
        } else {
            let temp = { ...axisState }
            temp[name] = value
            setAxisState(temp)
        }
    }

    const getCardYear = () => {
        let years = []
        for (let i = 0; i < 10; i++) {
            let value = new Date().getFullYear() + i
            let text = new Date().getFullYear() + i + ''
            years.push({ value: value, text: text })
        }


        let tempYear = [...years]
        setcardYears(tempYear)
    }

    const handleBack = () => {
        props.onBackBtnClick()
    }


async function getCalculationData() {
  const postRequest = {
            PaymentOption: 'JioPayNetbanking',
    TrackId: paymentData.customerData.PaymentRequest.TrackID,
    CardNumber: axisState.cardNumber.toString(),
  }

  const jsonBody = JSON.stringify(postRequest)

  const encryptedPostRequest = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(jsonBody),
    key,
    {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  )

  const postData = { payload: encryptedPostRequest.toString() }

  try {
        const url = `${MicroservicesBaseUrl.baseApiUrl}api/banking/CalculateTransactionCharges`

    // console.log('calling URL:', url)

    const { data: result } = await axios.post(url, postData)

    // console.log('charges raw result', result)

    if (result.statusCode === 200 && result.data) {
      const decryptedResponse = CryptoJS.AES.decrypt(
        result.data,
        key,
        {
          keySize: 128 / 8,
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      )

      const decrypted = decryptedResponse.toString(CryptoJS.enc.Utf8)
      const actualResponse = JSON.parse(decrypted)

    //   console.log('charges decrypted', actualResponse);
      props.setCharges(actualResponse);
      // set local state here if needed
    } else {
    //   console.log('charges non-200', result)
    }
  } catch (err) {
    // console.log('charges error', err)
  }
}

    const SubmitRequestJioPayNetBanking = () => {

        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'JioPayNetbanking',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            BankName: selectedBankCode,
            Cvv: '',
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: '',
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }
        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    // console.log("res",res)
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                                                // console.log("paymentResp",decrypted)
                        localStorage.setItem('gateway', 'JioPayNetbanking')

                        let actualResponse = JSON.parse(decrypted)
                         window.location.href=actualResponse;
                    } else {
                                                                    alertService.addError(res?.errorMessage);
                        // const transactionResponse = {
                        //     Comments: res.errorMessage,
                        //     Status: 'Transaction declined',
                        //     TransactionId: '',
                        //     TrackId: '',
                        //     Amount: '',
                        //     TransactionDate: '',
                        //     RedirectUrl:
                        //         paymentData.customerData.PaymentRequest
                        //             .RedirectUrl,
                        // }
                        // history.push({
                        //     pathname: '/TransactionStatus',
                        //     state: transactionResponse,
                        // })
                    }
                },
                (err) => {
                      const msg =
                        err?.response?.data?.errorMessage ||
                        err?.response?.data?.message ||
                        err?.message ||
                        'Request failed';
                    
                      alertService.addError(msg); 
                    //   console.error("❌ Error in createPaymentRequestData:", err);
                    // const transactionResponse = {
                    //     Comments:
                    //         'Please Contact Vayana Team for further details',
                    //     Status: 'Transaction declined',
                    //     TransactionId: '',
                    //     TrackId: '',
                    //     Amount: '',
                    //     TransactionDate: '',
                    //     RedirectUrl:
                    //         paymentData.customerData.PaymentRequest.RedirectUrl,
                    // }
                    // history.push({
                    //     pathname: '/TransactionStatus',
                    //     state: transactionResponse,
                    // })
                }
            )
        )
    }

    useEffect(() => {
        getCardYear()
    }, [])

useEffect(() => {
getCalculationData();
}, [])



    return (
        <div>
<Card sx={{ p: 1, boxShadow: 'none', minHeight: "50vh", display: 'flex', flexDirection: 'column' }}>
  <ValidatorForm style={{ flex: 1, display: 'flex', flexDirection: 'column' }} onSubmit={SubmitRequestJioPayNetBanking}>
    {/* TOP */}
    <Box>
      <Grid container sx={{ ml: '2px' }}>
        <Typography>Select a bank to continue</Typography>

        <FormControl fullWidth size="small" sx={{ mt: 2 }}>
          <InputLabel id="bank-select-label">Select bank</InputLabel>
          <Select
            labelId="bank-select-label"
            id="bank-select"
            label="Select bank"
            value={selectedBankCode}
            onChange={(e) => setSelectedBankCode(e.target.value)}
          >
            {nbBanks.map((b) => (
              <MenuItem key={b.sysBankCode} value={b.sysBankCode}>
                {b.bankName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Box>
    {/* BOTTOM (sticks to bottom) */}
    <Box sx={{ mt: 'auto' }}>
      <Grid container sx={{ ml: '2px' }}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <button
                type="button"
                className="backButton"
                style={{ width: '100%', margin: '10px 0px' }}
                onClick={handleBack}
              >
                Back
              </button>
            </Grid>

            <Grid item xs={12} md={6}>
              <button
                className="btn"
                disabled={props.acceptCharges === false}
                style={{
                  width: '100%',
                  backgroundColor:
                    paymentData.customerData.UIConfig.ButtonBackgroundColor,
                  color: paymentData.customerData.UIConfig.ButtonTextColor,
                  opacity: props.acceptCharges === false ? '0.5' : '1',
                }}
              >
                Pay
              </button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  </ValidatorForm>
</Card>



        </div>
    )
}


export default JioPayNetBanking
